/**
 * Fixture rendered by `useAgentModelSupport()` for anonymous readers,
 * Storybook stories, and the live-failure fallback (PRD-9a / Guided Demos
 * pivot).
 *
 * The fixture mirrors `AgentModelSupportResponse` so the launch form's
 * matrix-driven rendering path works without any seeded `QueryClient`. We
 * use Anthropic / Claude Sonnet 4 as the default to match the
 * `LaunchAgentDialog.stories.tsx` story fixture (single-source-of-truth
 * for both design-time stories and the simulation runtime).
 */
import type { AgentModelSupportResponse } from '@reflex/shared';

export const agentModelSupportFixture: AgentModelSupportResponse = {
  // Fixture mode renders the launch form without a seeded agent-type registry,
  // so the dialog can't fall back to the "first registered" type. Pin the
  // default here (the fixture only defines claude-code) so the matrix-driven
  // model list resolves to the Anthropic catalog the docstring promises.
  defaultAgentType: 'claude-code',
  defaultAgentTypeSource: 'system_fallback',
  agents: {
    'claude-code': {
      status: 'available',
      agentType: 'claude-code',
      displayName: 'Claude Code',
      providers: [
        { id: 'anthropic', displayName: 'Anthropic', keyTypes: ['apiKey', 'subscription'] },
      ],
      endpoints: [
        {
          id: 'anthropic-api',
          displayName: 'Anthropic API',
          envVars: [{ name: 'ANTHROPIC_API_KEY', required: true, fromSecret: true }],
          availability: { available: true, reasons: [], missingEnvVars: [] },
        },
      ],
      providerEndpoints: [{ providerId: 'anthropic', modelEndpointId: 'anthropic-api' }],
      defaultEndpoint: 'anthropic-api',
      defaultProvider: 'anthropic',
      defaultModel: 'claude-sonnet-4-20250514',
      defaultSource: 'system_recommended',
      discovery: { method: 'static' },
      discoveredModels: [
        {
          id: 'claude-sonnet-4-20250514',
          displayName: 'Claude Sonnet 4',
          providerId: 'anthropic',
        },
        {
          id: 'claude-opus-4-20250514',
          displayName: 'Claude Opus 4',
          providerId: 'anthropic',
        },
      ],
      discoveryStatus: 'ready',
    },
  },
};
